import { useCallback } from "react";

import { Container, Dialog, Flex, Portal } from "@chakra-ui/react";
import { createOverlay } from "@chakra-ui/react";
import { useFormSubmitError } from "@features/errors/form-errors";
import { useIntl } from "react-intl";

import { SubPageTemplate } from "@shared/ui/templates/sub-page-template";

import { totpOverlayMessages } from "./messages";
import { TotpForm, type TotpFormValues } from "./totp-form";

export interface TOTOPOverlayProps {
  description: string;
  reset?: () => Promise<void>;
  submit: (code: string) => Promise<void>;
}

export const totpOverlay = createOverlay<TOTOPOverlayProps>((props) => {
  const { description, reset, submit, onOpenChange, ...rest } = props;
  const { formatMessage } = useIntl();
  const handleSubmit = useCallback(
    async ({ code }: TotpFormValues) => {
      await submit(code);
      onOpenChange?.({ open: false });
    },
    [onOpenChange, submit],
  );
  const handleReset = useCallback(async () => {
    if (reset) {
      await reset();
    }
    onOpenChange?.({ open: false });
  }, [onOpenChange, reset]);
  const handleBack = useCallback(() => {
    onOpenChange?.({ open: false });
  }, [onOpenChange]);
  const handleSubmitWithSubmitErrors = useFormSubmitError(handleSubmit);
  return (
    <Dialog.Root {...rest} modal={false} size="full">
      <Portal>
        <Dialog.Positioner top="14">
          <Dialog.Content backgroundColor="bg" boxShadow="none">
            <Flex direction="column">
              <Container
                as={Flex}
                flex={1}
                flexDirection="column"
                maxW="lg"
                pt="8"
              >
                <SubPageTemplate
                  subTitle={description}
                  title={formatMessage(totpOverlayMessages.title)}
                  onBack={handleBack}
                >
                  <TotpForm
                    onReset={reset ? handleReset : undefined}
                    onSubmit={handleSubmitWithSubmitErrors}
                  />
                </SubPageTemplate>
              </Container>
            </Flex>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
});
